<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='5'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright" v-loading="loading">
          <!--右侧开始-->
          <div class="cght_htmainrighttop">
            <div class="cght_htmainrighttopl">个人资料</div>
            <div class="cght_htmainrighttopr">
              <div class="cght_htmainrighttoprl">
                <router-link :to="{path:'/Address'}">我的收货地址</router-link>
              </div>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <el-menu default-active="1" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item index="1">基本信息</el-menu-item>
              <el-menu-item index="2">头像照片</el-menu-item>
              <el-menu-item index="3" v-if="current_user.MAccountRole==1">价格修正</el-menu-item>
            </el-menu>
            <!--右边内容区域开始-->
            <!-- <div class="m m-user plus-UNTRY">
              <div class="mc">
                <span class="rank">银牌</span>
                <a class="avatar" href="">
                  <img v-real-img="current_user.headimgurl" src="../../assets/images/touxiang02.jpg">
                </a>
                <div class="user">
                  <a href="" class="user-name" target="_blank">{{current_user.account}}</a>
                </div>
                <div class="score">
                  <a class="score-vip" href="" target="_blank"><i class="icon-sprite"></i>京享值 3430</a>
                  <a class="score-bai" href="" target="_blank">开启小白守约特权</a>
                </div>
              </div>
              <div class="mb">
                <div class="text">
                  <em>开通PLUS会员尊享</em>
                  <span>全年360元运费券礼包</span>
                </div>
                <a class="button" href="" target="_blank">立即开通</a>
              </div>
            </div> -->
            <!-- <div class="cght_grzlti">基本资料</div> -->
            <div v-if="showindex == '1'" class="cght_grzltitop">
              <div class="cght_aqzxinxleft">个人资料</div>
              <div class="cght_aqzxinxword">{{current_user.account}}</div>
            </div>
            <div v-if="showindex == '1'" class="cght_grzlmain">
              <div class="cght_grzlmaindiv">
                <span>用户名：</span>
                <div class="cght_grzlmainname">{{current_user.account}}</div>
              </div>
              <div class="cght_grzlmaindiv">
                <span>姓名：</span>
                <div class="cght_grzlmainname">
                  <el-input v-model="name" placeholder="请输入姓名"></el-input>
                  <!-- {{current_user.name}} -->
                </div>
              </div>
              <div class="cght_gongyongqx mymemclass">
                <span class="birthday">性别：</span>
                <div class="cght_grzlmainxb">
                  <el-radio v-model="current_user.sex" label="男">男</el-radio>
                  <el-radio v-model="current_user.sex" label="女">女</el-radio>
                </div>
              </div>
              <div class="cght_gongyongqx mymemclass">
                <span class="birthday">生日：</span>
                <el-date-picker
                  v-model="current_user.birthday"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择生日">
                </el-date-picker>
              </div>
              <div class="cght_grzlmaindiv">
                <span>手机号码：</span>
                <div class="cght_grzlmaindivtel">{{current_user.tel}}</div>
                <div class="cght_grzlmaindivtela">
                  <router-link :to="{path:'/Safety'}">修改</router-link>
                </div>
              </div>
              <div class="cght_grzlmaindiv" v-if="current_user.email">
                <span>邮箱：</span>
                <div class="cght_grzlmaindivtel">{{current_user.email}}</div>
                <div class="cght_grzlmaindivtela">
                  <router-link :to="{path:'/Safety'}">修改</router-link>
                </div>
              </div>
              <div class="cght_gongyongqx">
                <span class="birthday">&emsp;</span>
                <el-button type="primary" icon="el-icon-edit" size="mini" @click="subMember">保存</el-button>
              </div>
            </div>
            <div v-if="showindex == '2'" class="cght_grzltitop">
              <div class="cght_aqzxinxleft">头&emsp;&emsp;像</div>
              <div class="cght_aqzxinxpoto">
                <img v-real-img="current_user.headimgurl" src="../../assets/images/touxiang02.jpg" width="40" height="40" yyzz/>
              </div>
            </div>
            <div v-if="showindex == '2'" class="cght_grzlmain">
              <div class="cght_grzlmaintoux">
                <div class="cght_grzlmaintouxlkb"></div>
                <div class="cght_grzlmaintouxl">
                  <img v-real-img="current_user.headimgurl" src="../../assets/images/touxiang02.jpg" width="100" height="100"/>
                </div>
                <!-- <form picture=picture> -->
                  <div class="cght_grzlmaintouxlan">
                    <!-- <a style="position: relative;">
                      <input style="position:absolute;left:0rem; width: 186px; height: 38px;opacity:0;filter:alpha(opacity=0);cursor: pointer;" type="file" name="photo" accept="image/*" sctp/>上传头像
                    </a> -->
                    <el-upload
                      class="avatar-uploader"
                      :action = url
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload">
                      <i class="el-icon-plus avatar-uploader-icon">上传头像</i>
                    </el-upload>
                  </div>
                <!-- </form> -->
              </div>
            </div>
            <div v-if="showindex == '3'" class="cght_grzlmain">
              <div class="cght_grzlmaintoux">
                <el-form :model="formOrderData" ref="FormOrder" label-width="100px" class="demo-ruleForm">
                  <el-row>
                    <el-col :span="11">
                      <el-form-item label="上传文件">
                        <el-upload
                          ref="upload"
                          class="upload-demo"
                          :action="upload_url"
                          :on-success="handlesuccess"
                          :before-upload="beforeAvatarUploadss"
                          accept=".xls,.xlsx"
                          :file-list="fileList"
                          :headers="requestHeaders"
                          :auto-upload="true"
                          :multiple="false"
                          :limit="1">
                          <el-button slot="trigger" size="small" type="primary">上传模板文件</el-button>
                        </el-upload>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11"><el-button type="primary" icon="el-icon-edit" size="mini" @click="UpdateGoodsPB">保存</el-button></el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import apiConfig from '../../../config/api.config.js'
import { mapGetters } from 'vuex'
import { getToken } from '@/utils/auth'
import api from '@/api/user'

export default {
  name: 'PersonalData',
  components: { Top, LeftNav, Bottom },
  data () {
    return {
      name: '',
      url: apiConfig.baseUrl + '/admin/Upload/Upload',
      showindex: '1',
      upload_url: apiConfig.baseUrl + '/admin/Upload/UploadGoodsPrice',
      requestHeaders: {
        'X-Token': getToken()
      },
      fileList: [],
      formOrderData: {
        filename: ''
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  mounted () {
    this.name = this.current_user.name
  },
  methods: {
    handleAvatarSuccess (res, file) {
      api.subMember({'headimgurl': res.message}).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch('user/saveInformation', res).then(() => {
            this.current_user.headimgurl = res.message
            this.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success'
            })
          })
        }
      })
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    subMember () {
      api.subMember({'birthday': this.current_user.birthday, 'sex': this.current_user.sex, 'name': this.name}).then(res => {
        this.$store.dispatch('user/saveInformation', res).then(() => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success'
          })
        })
      })
    },
    handleSelect (key) {
      this.showindex = key
    },
    handlesuccess (response, file) {
      this.subloading = false
      if (response.code === 20000) {
        // this.formData.filename = response.message
        this.formOrderData.filename = response.savename
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUploadss (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      this.subloading = true
      return (extension || extension2) && isLt2M
    },
    UpdateGoodsPB () {
      // this.loading = true
      api.UpdateGoodsPB(this.formOrderData).then(res => {
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
 .birthday{
    padding-right: 5px;
    float: left;
    display: block;
    font-size: 14px;
    color: #666666;
    text-align: right;
    width: 195px;
 }
 .mymemclass{
    height: 34px;
    line-height: 34px;
    padding-bottom: 15px;
 }
 .m-user {
    float: left;
    margin-bottom: 0;
    width: 250px;
    height: 243px;
    -webkit-box-shadow: 2px 2px 10px rgb(0 0 0 / 30%);
    box-shadow: 2px 2px 10px rgb(0 0 0 / 30%);
  }
  .plus-UNTRY .mc {
    background-color: #436aa6;
  }
  .m-user .mc {
    position: relative;
    height: 187px;
    text-align: center;
    padding: 1px;
  }
  .m-user .rank {
    position: absolute;
    top: 80px;
    left: 105px;
    z-index: 3;
    padding-left: 1px;
    width: 40px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background-color: #fff;
    border-radius: 10px;
    -webkit-box-shadow: 2px 4px 4px 0 rgb(41 41 41 / 50%);
    box-shadow: 2px 4px 4px 0 rgb(41 41 41 / 50%);
    color: #343434;
  }
  .m-user .avatar, .m-user .avatar img {
    width: 64px;
    height: 64px;
  }
  .m-user .avatar {
    display: block;
    position: relative;
    z-index: 2;
    margin: 20px auto;
    border-radius: 100%;
    border: 4px solid #fff;
    -webkit-box-shadow: 3px 2px 10px 0 rgb(79 5 1 / 84%);
    box-shadow: 3px 2px 10px 0 rgb(79 5 1 / 84%);
    overflow: hidden;
  }
  .m-user .user {
    display: inline-block;
    margin-bottom: 10px;
    height: 24px;
    overflow: hidden;
  }
  .m-user .user-name {
    font: 700 18px/20px Arial;
    color: #fff;
  }
  .m-user .score a, .m-user .score span {
    padding: 0 10px;
    border: 1px solid #fff;
    color: #fff;
  }
  .score a, .m-user .score span {
    display: inline-block;
    margin: 0 5px;
    height: 22px;
    line-height: 22px;
    border-radius: 12px;
  }
  .m-user .mb {
    padding: 10px 20px;
    height: 36px;
    background-color: #232331;
  }
  .m-user .text {
    float: left;
    margin-right: 10px;
    color: #f4ca3a;
  }
  .m-user .text em {
    font-size: 13px;
    font-weight: 700;
  }
  .m-user .text em, .m-user .text span {
    display: block;
    margin: -6px;
  }
  .m-user .button {
      float: right;
      padding: 0 10px;
      margin-top: 5px;
      height: 26px;
      line-height: 26px;
      border-radius: 14px;
      background-color: #f4ca3a;
      color: #232331;
      font-weight: 700;
      text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/view/member/personal_data.vue